import type { Node } from './../ricos-schema/legacy/wix/rich_content/v1';

import { ANCHORABLE_PLUGIN_NODES, ANCHORABLE_TEXT_NODES } from './constants';
import type { AnchorableNodes } from './types';

export const isAnchorableNode = (node: Node): node is Node & { type: AnchorableNodes } => {
  return (
    ANCHORABLE_PLUGIN_NODES.includes(node.type as any) ||
    ANCHORABLE_TEXT_NODES.includes(node.type as any)
  );
};
